import { jsx } from "@emotion/react/jsx-runtime";
import { Checkbox as Checkbox$1 } from "@mui/material";
import { Check, Minus } from "react-feather";
import { forwardRef } from "react";
import { checkboxStyles, boxStyles, checkIconStyles } from "./Checkbox.styles.js";
const BoxIcon = ({
  children
}) => /* @__PURE__ */ jsx("span", { className: "Sunbeam-checkbox-outline", css: boxStyles, children });
const CheckedIcon = () => /* @__PURE__ */ jsx(BoxIcon, { children: /* @__PURE__ */ jsx(Check, { css: checkIconStyles, size: 16 }) });
const IndeterminateIcon = () => /* @__PURE__ */ jsx(BoxIcon, { children: /* @__PURE__ */ jsx(Minus, { css: checkIconStyles, size: 16 }) });
const Checkbox = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(Checkbox$1, { css: checkboxStyles, icon: /* @__PURE__ */ jsx(BoxIcon, {}), checkedIcon: /* @__PURE__ */ jsx(CheckedIcon, {}), indeterminateIcon: /* @__PURE__ */ jsx(IndeterminateIcon, {}), ref, ...props });
});
export {
  Checkbox
};
//# sourceMappingURL=Checkbox.js.map
